/**
 * Site/brand configuration based on current origin.
 * Kantus: kantusofficial.com, localhost, 127.0.0.1
 * Jorjet: jorjet.ir and others
 */

export const BRAND_JORJET = "jorjet";
export const BRAND_KANTUS = "kantus";

export const isKantus = () => {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return (
    host.includes("kantusofficial.com") ||
    host.includes("localhost") ||
    host === "127.0.0.1" ||
    host.startsWith("127.0.0.1")
  );
};

export const getBrand = () => {
  return isKantus() ? BRAND_KANTUS : BRAND_JORJET;
};

/**
 * Get brand display name in Persian.
 * Returns "کانتوس" for Kantus, "ژورژت" for Jorjet.
 */
export const getBrandName = () => {
  return isKantus() ? "کانتوس" : "ژورژت";
};

/**
 * Replace ژورژت with current brand name in text.
 * Use for dynamic content from API (e.g. About).
 */
export const replaceBrandInText = (text) => {
  if (text == null || typeof text !== "string") return text;
  if (!isKantus()) return text;
  return text.replace(/ژورژت/g, "کانتوس");
};

/**
 * Get logo path based on brand.
 */
export const getLogoPath = () => {
  return isKantus()
    ? "/assets/img/logo/kantus-logo.png"
    : "/assets/img/logo/logo-removebg.png";
};

/**
 * Get favicon path based on brand.
 */
export const getFaviconPath = () => {
  return isKantus()
    ? "/assets/img/kantus-favicon.png"
    : "/assets/img/favicon.png";
};

/**
 * Get contact email based on brand.
 */
export const getContactEmail = () => {
  return isKantus() ? "info@kantusofficial.com" : "info@jorjet.ir";
};

/**
 * Get Instagram URL based on brand.
 */
export const getInstagramUrl = () => {
  return isKantus()
    ? "//instagram.com/Kantus.Official"
    : "//instagram.com/jorjet.official";
};

/**
 * Get Telegram URL based on brand.
 */
export const getTelegramUrl = () => {
  return isKantus() ? "https://t.me/kantus_suit" : "//t.me/+cRfd829xVJlmOTE0";
};

/**
 * Get WhatsApp URL based on brand.
 */
export const getWhatsAppUrl = () => {
  return isKantus()
    ? "https://whatsapp.com/channel/0029VbBosXfHVvTW1aQF3x1b"
    : "//wa.me/+989999618661";
};

/**
 * Get API base URL based on brand.
 * Kantus: api.kantusofficial.com, Jorjet: api.jorjet.ir
 */
export const getApiBaseUrl = () => {
  if (typeof window === "undefined") {
    return process.env.REACT_APP_API_URL || "https://api.jorjet.ir/api/v1";
  }
  return isKantus()
    ? "https://api.kantusofficial.com/api/v1"
    : process.env.REACT_APP_API_URL || "https://api.jorjet.ir/api/v1";
};

/**
 * Get site title based on brand (for document title).
 */
export const getSiteTitle = () => {
  return isKantus() ? "Kantus" : "Jorjet";
};
